<template>
	<div class="acknowledgements mh-700">
		<v-layout row wrap class="padded">
               <v-row>
                    <v-col>
                              <h1>Acknowledgements</h1>
                              <p>
							The images on this site were sourced from a range of talented artists, as given below:                                   
                                   <ul>
                                        <li>
                                             <a href="https://unsplash.com/@wildhoney?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
                                             John Fowler</a>,
                                        </li>
                                        <li>
                                             <a href="https://unsplash.com/@squillen?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
                                             Sean Quillen</a>
                                        </li>
                                        <li>
							          <a href="https://unsplash.com/@nicolegeri?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
                                             Nicole Geri</a>
                                        </li>
                                        <li>
							          <a href="https://unsplash.com/@raychelsnr?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
                                             Raychel Sanner</a>
                                        </li>
                                        <li>
							          <a href="https://unsplash.com/@mdherren?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
                                             Michael Herren</a>
                                        </li>
                                        <li>
							          <a href="https://unsplash.com/@pierrejeanneret?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
                                             Pierre Jeanneret</a>,<br>
                                        </li>
                                        <li>
                                             <a href="https://unsplash.com/@hgullixson?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
                                             Hannah Gullixson</a>
                                        </li>
                                        <li>
                                             <a href="https://scop.io/collections/vendors?q=Lynne+Bookey">
                                             Lynne Bookey</a>
                                        </li>
                                        <li>
							          <a href="https://scop.io/collections/vendors?q=saravut+vanset">
                                             saravut vanset</a>
                                        </li>
                                        <li>
                                             <a href="https://unsplash.com/@its_tgain?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
                                             Tom Gainor</a>
                                        </li>
                                   </ul>
						</p>
                    </v-col>
               </v-row>
          </v-layout>
     </div>
</template>

<script>
export default {
	name: 'Acknowledgements',
	components: {
		
	},
	methods: {

	}
};
</script>
<style src="../style.css"></style>